export const assignmentProgress = (value: any) => {
  if (value.totalUsers == 0 && value.submittedUsers == 0) return 0;

  return Math.round((value.submittedUsers / value.totalUsers) * 100);
};
